import { buildMessage, ValidateBy, ValidationOptions } from 'class-validator';
import { Types } from 'mongoose';

export const IsObjectId = (validationOptions?: ValidationOptions): PropertyDecorator =>
  ValidateBy(
    {
      name: 'is-object-id',
      validator: {
        defaultMessage: buildMessage((eachPrefix) => `${eachPrefix}$property is not a valid objectId`, validationOptions),
        validate: (value: string) => Types.ObjectId.isValid(value),
      },
    },
    validationOptions
  );
